import type { ProgramYearModel, StatutoryAgeModel } from "@/models";

export type DOBRange = {
  minDOB: string;
  maxDOB: string;
  programYearCode: string;
};

function toISODay(value?: string): string | null {
  if (!value) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  return m ? `${m[1]}-${m[2]}-${m[3]}` : null;
}

export function getCurrentProgramYear(
  programYears: ProgramYearModel[]
): ProgramYearModel | undefined {
  const today = new Date().toISOString().slice(0, 10);
  return programYears.find((py) => {
    const start = toISODay(py.EffectiveStartDate);
    const end = toISODay(py.EffectiveEndDate);
    return !!start && !!end && start <= today && today <= end;
  });
}

export function getValidDOBRange(
  programYear: ProgramYearModel | undefined,
  statutoryAges: StatutoryAgeModel[] | undefined
): DOBRange | undefined {
  if (!programYear || !statutoryAges?.length) return undefined;

  const end = toISODay(programYear.EffectiveEndDate);
  if (!end) return undefined;

  const targetServiceYear = Number(end.slice(0, 4));
  const targetServiceMonth = Number(end.slice(5, 7)) - 1;

  const match = statutoryAges.find(
    (sa) =>
      sa.ServiceYear === targetServiceYear &&
      sa.ServiceMonth === targetServiceMonth
  );
  if (!match) return undefined;

  const minDOB = toISODay(match.StatutoryOlderStartDate);
  const maxDOB = toISODay(match.StatutoryTwoEndDate);
  if (!minDOB || !maxDOB) return undefined;

  return { minDOB, maxDOB, programYearCode: programYear.Code };
}

export function isDOBOutOfRange(dob: string, range: DOBRange): boolean {
  const d = toISODay(dob);
  if (!d) return false;
  return d < range.minDOB || d > range.maxDOB;
}
